export const BAND_LANGUAGES: { code: string, labelKey: string }[] = [
  { code: 'PL', labelKey: 'FORMS.BAND.POLISH' },
  { code: 'EN', labelKey: 'FORMS.BAND.ENGLISH' },
  { code: 'PT', labelKey: 'FORMS.BAND.PORTUGESE' },
  { code: 'NO', labelKey: 'FORMS.BAND.NORSK' },
  { code: 'FR', labelKey: 'FORMS.BAND.FRANCE' },
  { code: 'IT', labelKey: 'FORMS.BAND.ITALIAN' },
  { code: 'DE', labelKey: 'FORMS.BAND.GERMAN' },
  { code: 'NL', labelKey: 'FORMS.BAND.NETHERLAND' },
  { code: 'sr', labelKey: 'FORMS.BAND.SERBIAN' },
  { code: 'LV', labelKey: 'FORMS.BAND.LATVIAN' },
  { code: 'RU', labelKey: 'FORMS.BAND.RUSSIAN' },
  { code: 'ET', labelKey: 'FORMS.BAND.ESTONIAN' },
  { code: 'SL', labelKey: 'FORMS.BAND.SLOVENIAN' },
  { code: 'LT', labelKey: 'FORMS.BAND.LITHUANIAN' },
  { code: 'SK', labelKey: 'FORMS.BAND.SLOVAK' },
  { code: 'FI', labelKey: 'FORMS.BAND.FINNISH' },
  { code: 'cs', labelKey: 'FORMS.BAND.CZECH' },
  { code: 'EL', labelKey: 'FORMS.BAND.GREEK' }
];

/**
 * Kod języka opaski.
 *
 * Standardem jest kod języka ISO 639-1 — dla czeskiego `cs`. Lista wyboru w panelu
 * miała przez długi czas kod KRAJU (`CZ`), więc takie wartości zdążyły trafić do bazy
 * i wracają z API. Stary rekord pokazywałby wtedy puste pole, bo `<select>` dopasowuje
 * wartość dokładnie, z uwzględnieniem wielkości liter.
 *
 * Sprowadzamy więc wariantowe zapisy do kodu z listy. Kodów, których nie znamy, nie
 * ruszamy — mają dojść do pola bez zmian i tam się nie dopasować, zamiast po cichu
 * zamienić się w cudzy język.
 */
const BAND_LANGUAGE_ALIASES: { [variant: string]: string } = {
  CZ: 'cs',
  cz: 'cs',
  CS: 'cs',
  RS: 'sr',
  rs: 'sr',
  SR: 'sr'
};

export function normalizeBandLanguage(value: any): any {
  if (typeof value !== 'string') {
    return value;
  }
  const code = value.trim();
  return BAND_LANGUAGE_ALIASES[code] !== undefined ? BAND_LANGUAGE_ALIASES[code] : code;
}

/**
 * Odpowiedź z danymi pacjenta ze skorygowanym kodem języka opaski.
 *
 * Poprawiamy ją raz, na granicy z API, zamiast w każdym ekranie z osobna — dzięki temu
 * kolejny widok czytający dane opaski dostaje właściwy kod bez pamiętania o tym kroku.
 * Zwracamy nowy obiekt, żeby nie zmieniać pod ręką tego, co przyszło z serwera.
 */
export function withNormalizedBandLanguage(response: any): any {
  if (!response || typeof response !== 'object' || !response.band || typeof response.band !== 'object') {
    return response;
  }
  return {
    ...response,
    band: { ...response.band, lang_band: normalizeBandLanguage(response.band.lang_band) }
  };
}

/**
 * Godzina ciszy nocnej dopełniona zerem: API zwraca zarówno "8:30", jak i "08:30",
 * a pola formularza oczekują dłuższego zapisu.
 *
 * Wartość spoza tekstu oddajemy nietkniętą. Wcześniej sprawdzenie brzmiało
 * `!= undefined`, więc liczba przechodziła dalej i `.substring()` rzucał wyjątkiem
 * w środku wczytywania — ekran zostawał wtedy z wartościami domyślnymi zamiast
 * z danymi pacjenta, bez śladu dla użytkownika.
 */
function padNightHour(value: any): any {
  if (typeof value !== 'string') {
    return value;
  }
  // Dopełniamy WYŁĄCZNIE zapis H:MM. Poprzednia wersja szukała dwukropka w dwóch
  // pierwszych znakach i przycinała wynik do sześciu ostatnich, więc "8:30:00"
  // zamieniała w ":30:00" — a zapis z sekundami też z API przychodzi.
  return /^\d:\d\d$/.test(value) ? '0' + value : value;
}

/** Odpowiedź z danymi pacjenta z godzinami ciszy nocnej sprowadzonymi do jednego zapisu. */
export function withNormalizedBandHours(response: any): any {
  if (!response || typeof response !== 'object' || !response.band || typeof response.band !== 'object') {
    return response;
  }
  return {
    ...response,
    band: {
      ...response.band,
      night_start: padNightHour(response.band.night_start),
      night_stop: padNightHour(response.band.night_stop)
    }
  };
}
